import { ImageWithFallback } from "./ImageWithFallback";
import ipad3 from "../../assets/landing/uae-4.jpg";
import ipad4 from "../../assets/landing/uae-5.jpg";
import ipad5 from "../../assets/landing/uae-6.jpg";

const FEATURES = [
  {
    title: "Trending Venues",
    desc: "Discover the most popular cafés, restaurants, and nightlife spots across the UAE.",
  },
  {
    title: "Real Reviews",
    desc: "Read authentic ratings and reviews before choosing where to go.",
  },
  {
    title: "Smart Discovery",
    desc: "Find amazing places near you instantly using location-based discovery.",
  },
  {
    title: "Exclusive Offers",
    desc: "Discover promotions and special offers from participating venues.",
  },
];

export function LandingDeviceShowcase() {
  return (
    <section id="discover" className="lp-py-16 lp-px-6 lp-relative">
      <div className="lp-max-6xl lp-mx-auto">
        
        {/* ==================== 4. DISCOVERY EXPERIENCE ==================== */}
        <div className="lp-grid lp-grid-cols-1 md-cols-2 lp-gap-12 lp-items-center lp-mb-12">
          
          {/* Left Column: 3 Phone Mockups overlapping */}
          <div className="lp-relative lp-flex lp-justify-center lp-items-center lp-h-80 lp-w-full">
            <div className="lp-relative lp-flex lp-items-end lp-justify-center lp-w-full" style={{ maxWidth: 450 }}>
              
              {/* Left phone - Discover page */}
              <div className="lp-w-28p lp-op-60 lp-transition lp-tilt-left" style={{ zIndex: 5 }}>
                <ImageWithFallback
                  src={ipad3}
                  alt="Discover page mockup"
                  className="lp-w-full lp-r-24 lp-shadow-2xl"
                  style={{ border: "2px solid rgba(255,255,255,0.05)" }}
                />
                <div className="lp-text-center lp-text-xs lp-text-muted lp-mt-2">Discover</div>
              </div>

              {/* Center phone - Venue details */}
              <div className="lp-w-36p lp-z-10" style={{ transform: "scale(1.05) translateY(-5px)", filter: "drop-shadow(0 15px 30px rgba(0,0,0,0.4))" }}>
                <ImageWithFallback
                  src={ipad4}
                  alt="Venue details mockup"
                  className="lp-w-full lp-r-28 lp-shadow-2xl"
                  style={{ border: "3px solid rgba(255,255,255,0.08)" }}
                />
                <div className="lp-text-center lp-text-xs lp-text-blue lp-font-medium lp-mt-2">Venue Details</div>
              </div>

              {/* Right phone - Category browsing */}
              <div className="lp-w-28p lp-op-60 lp-transition lp-tilt-right" style={{ zIndex: 5 }}>
                <ImageWithFallback
                  src={ipad5}
                  alt="Category browsing mockup"
                  className="lp-w-full lp-r-24 lp-shadow-2xl"
                  style={{ border: "2px solid rgba(255,255,255,0.05)" }}
                />
                <div className="lp-text-center lp-text-xs lp-text-muted lp-mt-2">Categories</div>
              </div>

            </div>
          </div>

          {/* Right Column: Content Text */}
          <div>
            <p
              className="lp-text-blue lp-text-xs lp-uppercase lp-tracking-wide lp-mb-3"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              Discovery Experience
            </p>
            <h2
              className="lp-text-dark lp-mb-6"
              style={{
                fontFamily: "'Fraunces', serif",
                fontWeight: 600,
                letterSpacing: "-0.025em",
                fontSize: "clamp(2rem, 4.5vw, 3.2rem)",
                lineHeight: 1.1,
              }}
            >
              Explore Amazing Places Around You
            </h2>
            <div
              className="lp-text-muted lp-leading-relaxed lp-flex lp-flex-col lp-gap-4"
              style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 300, fontSize: "1.05rem" }}
            >
              <p>
                Hubscroll helps people discover great places to eat, drink, and socialize across the UAE.
              </p>
              <p>
                With Hubscroll you can explore trending cafés, popular restaurants, hidden gems, and nightlife destinations all in one place.
              </p>
              <p>
                Our intelligent discovery system helps you find the best venues near you, while detailed venue profiles allow you to browse photos, reviews, and useful information before visiting.
              </p>
            </div>
          </div>

        </div>

        {/* ==================== 5. KEY FEATURES ==================== */}
        <div className="lp-pt-6">
          {/* Section Divider with Header */}
          <div className="lp-section-divider">
            <span
              className="lp-text-dark lp-text-xl lp-uppercase lp-tracking-wide lp-px-4"
              style={{ fontFamily: "'Fraunces', serif", fontWeight: 500, letterSpacing: "0.05em" }}
            >
              Why People Love Hubscroll
            </span>
          </div>

          {/* Feature Cards Grid */}
          <div className="lp-grid lp-grid-cols-1 md-cols-2 lg-cols-4 lp-gap-6">
            {FEATURES.map((f, i) => (
              <div 
                key={i} 
                className="lp-r-2xl lp-p-6 lp-transition lp-border lp-bc-b10"
                style={{ 
                  minHeight: "200px",
                  background: "var(--lp-color-bg-surface)"
                }}
              >
                <h3
                  className="lp-text-dark lp-mb-2"
                  style={{ 
                    fontFamily: "'Fraunces', serif", 
                    fontWeight: 600, 
                    fontSize: "1.2rem", 
                    letterSpacing: "-0.01em" 
                  }}
                >
                  {f.title}
                </h3>
                <p 
                  className="lp-text-muted lp-text-sm lp-leading-relaxed" 
                  style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 300 }}
                >
                  {f.desc}
                </p>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
